import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ReactSelect from 'components/theme/Select'
import { groupOptionsSelector } from 'selectors'
import { handleGroupChange } from 'actions/contacts/addOrEdit'
import { themeObj } from 'components/withRoot'
import language from 'utils/vast-languagepack'
import { Hidden } from '@material-ui/core'

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: '28px',
    padding: '9px 0',
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 2,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: themeObj.palette.secondary.main,
    borderRadius: 15,
    padding: 4,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#fff',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    marginLeft: 4,
    ':hover': {
      backgroundColor: '#fff',
    },
  }),
}

export default connect(
  (state) => ({
    value: state.addOrEditContact.groupSelect.value,
    options: groupOptionsSelector(state),
  }),
  (dispatch) => bindActionCreators({ handleGroupChange }, dispatch),
)(({ value, options, handleGroupChange }) => (
  <>
    <Hidden mdUp>
      <ReactSelect
        styles={customStyles}
        value={value}
        onChange={(newValue, action) => handleGroupChange(newValue, action)}
        closeMenuOnSelect={false}
        isMulti
        isClearable={false}
        options={options}
        placeholder={language.general.shared.selectGroup}
        isSearchable={false}
      />
    </Hidden>
    <Hidden smDown>
      <ReactSelect
        styles={customStyles}
        value={value}
        onChange={(newValue, action) => handleGroupChange(newValue, action)}
        closeMenuOnSelect={false}
        isMulti
        isClearable={false}
        options={options}
        placeholder={language.general.shared.selectGroup}
      />
    </Hidden>
  </>
))
